import {BriefcaseIcon, CalendarIcon, CurrencyEuroIcon} from "@heroicons/react/outline";
import React from "react";

const HitDetails = props => {
    const {
        type,
        readable_period,
        readable_price
    } = props;

    return (
        <div className={'text-sm tracking-wide sw-1'}>
            <div className={'flex items-center gap-2'}>
                <BriefcaseIcon className={'w-4 h-4'}/>
                <p>{type}</p>
            </div>
            <div className={'flex items-center gap-2'}>
                <CalendarIcon className={'w-4 h-4'}/>
                <p>{readable_period}</p>
            </div>
            <div className={'flex items-center gap-2'}>
                <CurrencyEuroIcon className={'w-4 h-4'}/>
                <p>{readable_price}</p>
            </div>
        </div>
    )
}

export default HitDetails